import ToastContent from '@trackman/web-shared-components/components/Toast/ToastContent';
import { ToastProps } from '@trackman/web-shared-components';
import { observer } from 'mobx-react-lite';
import { useStores } from 'index';

export const Notifications = observer(() => {
  const notificationsStore = useStores().notificationStore;

  return (
    <div
      style={{
        top: '24px',
        right: '24px',
        zIndex: 2002,
        position: 'fixed',
        alignItems: 'center',
        justifyContent: 'flex-end',
      }}
      className='notification-toast'
    >
      {notificationsStore.toasts &&
        notificationsStore.toasts.map((toast: ToastProps, index: number) => {
          // Use custom error styles full json errors (default design is not suitable for large error messages)
          if (toast.severity === 'error') {
            return (
              <div key={index} className='card error-toast'>
                <div className='d-flex justify-content-between align-items-start mb-2'>
                  <strong className='text-danger'>{toast.header}</strong>
                  <button
                    onClick={() => notificationsStore.handleOnClose(toast.id ? toast.id : '')}
                    className='btn-close'
                    aria-label='Close'
                  >
                    ×
                  </button>
                </div>
                <pre className='error-message'>{toast.message}</pre>
              </div>
            );
          }

          // Use default ToastContent for non-error toasts
          return (
            <ToastContent
              onClose={() => notificationsStore.handleOnClose(toast.id ? toast.id : '')}
              key={index}
              severity={toast.severity}
              header={toast.header}
              message={toast.message}
              margin='8px'
            />
          );
        })}
    </div>
  );
});
